import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import CardHeader from "../CardHeader/CardHeader";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import CustomButton from "../CustomButton/CustomButton";
import theme from "../../theme/theme";
import { Auth } from "aws-amplify";
import CustomAlertLabel from "../CustomAlertLabel/CustomAlertLabel";
import CustomModal from "../CustomModal/CustomModal";
import { passwordRegex } from "../../Regex";
import LoadingBar from "../LoadingBar/LoadingBar";

const BodyWrapper = styled.div`
  text-align: left;

  .inputBoxSection {
    margin-top: 7%;
  }

  .buttonContainer {
    text-align: right;
    margin-top: 7%;
  }

  .instructionsContainer {
    margin-top: 7%;
    padding-left: 30px;

    .instructionPoint {
      list-style-type: circle;
      margin-left: 10px;
      color: #004576;
    }
  }

  .disclaimer {
    width: 100%;
    text-align: left;
    margin-top: 4%;
    text-decoration: underline;
    cursor: pointer;
  }

  .linkButton {
    text-decoration: underline;
    color: ${theme.colors.primaryStrong};
    font-weight: 700;
    cursor: pointer;
  }
`;

const ChangeDefaultPasswordForm = () => {
  const history = useHistory();
  const cookies = new Cookies();
  const dispatch = useDispatch();

  const { loginSuccessResponse, loading } = useSelector((state) => state.user);

  const [customAlertMessage, setCustomAlertMessage] = useState("");
  const [isLoaded, setIsLoaded] = useState(true);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [customModalProps, setCustomModalProps] = useState({
    isVisible: false,
    headerMessage: "",
    subHeaderMessage: "",
    primaryButtonText: "",
  });

  // useEffect(() => {
  //   if (loading) {
  //     //setIsLoaded(true);
  //   }
  // }, [loading]);

  const handleCustomModalOnClose = () => {
    setCustomModalProps((state) => ({
      ...state,
      isVisible: false,
    }));
  };

  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    if (textBoxName === "password") {
      setPassword(value);
    } else if (textBoxName === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const handleCustomTextBoxKeyPress = (event) => {
    if (event.key === "Enter") {
      loginUser();
    }
  };

  const loginUser = async () => {
    if (password && confirmPassword) {
      setIsLoaded(false);
      Auth.completeNewPassword(loginSuccessResponse, password).then((user) => {
        setIsLoaded(true);
        history.push(`/login/passwordChanged`);
      });
    }
  };

  // const handleCustomModalPrimaryButtonClick = () => {
  //   if (customModalProps.primaryButtonText === "Verify mail")
  //     history.push(`/mail-verification/${mailId}/fromModal`);
  //   else
  //     setCustomModalProps((state) => ({
  //       ...state,
  //       isVisible: false,
  //     }));
  // };

  return (
    <BodyWrapper>
      {!isLoaded && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      {customModalProps.isVisible && (
        <CustomModal
          onClose={handleCustomModalOnClose}
          headerMessage={customModalProps.headerMessage}
          subHeaderMessage={customModalProps.subHeaderMessage}
          primaryButtonText={customModalProps.primaryButtonText}
          // onClick={handleCustomModalPrimaryButtonClick}
        />
      )}
      <CardHeader text={"Change Password"} />
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="New Password"
          errorMessage="Not a valid password"
          value={password}
          name="password"
          type={"password"}
          regexCode={passwordRegex}
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="inputBoxSection">
        <CustomTextBox
          placeholder="Enter New Password"
          errorMessage="Not a valid password"
          value={confirmPassword}
          name="confirmPassword"
          type={"password"}
          regexCode={passwordRegex}
          onBlur={handleCustomTextBoxOnBlur}
          onKeyPress={handleCustomTextBoxKeyPress}
        />
      </div>
      <div className="instructionsContainer">
        <ul>
          <li className="instructionPoint">
            Password must contain a lower case letter
          </li>{" "}
          <li className="instructionPoint">
            Password must contain an upper case letter
          </li>{" "}
          <li className="instructionPoint">Password must contain a number</li>{" "}
          <li className="instructionPoint">
            Password must contain at least 8 characters
          </li>{" "}
          <li className="instructionPoint">
            Password must contain a special character or a space
          </li>
          <li className="instructionPoint">
            Password must not contain a leading or trailing space
          </li>
        </ul>
      </div>
      <div className="buttonContainer">
        <CustomButton text={"Save"} onClick={loginUser} />
        <CustomAlertLabel message={customAlertMessage} />
      </div>
    </BodyWrapper>
  );
};

export default ChangeDefaultPasswordForm;
